import React from 'react';
import Head from 'next/head';
import Redirect from 'components/UtilityComponents/Redirect';

const RoommateQuestionnaire = () => {
  const redirectUrl = '/for-renters'
  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Roommate Questionnaire</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://www.soulrooms.com/roommate-questionnaire" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="SIMPLIFIED shared living FOR AWESOME PEOPLE" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta property="og:locale" content="en_CA" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@SoulRoomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta name="twitter:description" content="SIMPLIFIED shared living FOR AWESOME PEOPLE" />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <link rel="canonical" href="https://www.soulrooms.com/roommate-questionaire" />
      </Head>
     <Redirect url={redirectUrl} />
    </div>
  );
};

export default RoommateQuestionnaire;
